module.exports = __webpack_public_path__ + "img/green_051.5ae943a5.png";